import React from 'react'

export const backgroundImageTourConfig = (t) => ({
    id: 'background-image-settings',
    name: t('tour:background_image_settings_name'),
    description: t('tour:background_image_settings_desc'),
    icon: 'picture',
    hidden: true,
    disableAutoResume: true,
    steps: [
        {
            target: '.ant-modal-content',
            title: t('tour:background_image_settings_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:background_image_settings_step_0_content')}</p>
                </div>
            ),
            placement: 'center',
            waitFor: '.ant-modal-content'
        },
        {
            target: '[data-tour="bg-change-image"]',
            title: t('tour:background_image_settings_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:background_image_settings_step_1_content')}</p>
                </div>
            ),
            placement: 'bottom',
            waitFor: '[data-tour="bg-change-image"]'
        },
        {
            target: '[data-tour="bg-opacity"]',
            title: t('tour:background_image_settings_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:background_image_settings_step_2_content')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="bg-remove"]',
            title: t('tour:background_image_settings_step_3_title'),
            content: (
                <div>
                    <p>{t('tour:background_image_settings_step_3_content')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="bg-apply"]',
            title: t('tour:background_image_settings_step_4_title'),
            content: (
                <div>
                    <p>{t('tour:background_image_settings_step_4_content')}</p>
                </div>
            ),
            placement: 'top',
        }
    ]
})
